export default {"src":"/_next/static/media/support.dca707a6.svg","height":50,"width":50,"blurWidth":0,"blurHeight":0};